import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { textSObj } = typographyStyles;

export const rootCss = {
  zIndex: 14,
};

export const modalContentWrapperCss = {
  height: "auto",
};

export const standardWrapperCss = {
  marginBottom: "24px",
  "&:last-child": {
    marginBottom: 0,
  },
};

export const standardLinkCss = [
  {
    textDecoration: "none",
  },
];

export const standardDescriptionCss = [
  textSObj,
  {
    color: ui.neutral[500],
    margin: "8px 0 0",
  },
];

export const hideFooterCss = {
  display: "none",
};
